import I18N from '@leverege/i18n';
import { Layout, Context } from '@leverege/plugin';
import MoltenUtil from "../../../MoltenUtil.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.dataViewers.layout.DashboardPicker');
export default {
  id: 'molten.dataViewers.layout.DashboardPicker',
  name: tf('name'),
  matches: {
    use: 'layoutActionBar'
  },
  layout: {
    sort: 'z'
  },
  handles: context => {
    const {
      layout
    } = context;
    if (layout == null) {
      return false;
    }
    return true;
  },
  appearance({
    context
  }) {
    const {
      layout: {
        layoutVersion
      }
    } = context;
    const groupName = layoutVersion?.name || t('default');
    const flt = Context.createMatch({
      use: 'mobileLayoutActionBar'
    });
    const sublayout = Layout.create(MoltenUtil.sortedPlugins('Action', flt));
    return {
      name: groupName,
      type: 'selector',
      iconOn: tIcon('iconOn', 'fa fa-chevron-up fa-fw'),
      iconOff: tIcon('iconOff', 'fa fa-chevron-down fa-fw'),
      variant: 'layoutSelector',
      sublayout,
      sublayoutContext: context
    };
  },
  perform({
    context
  }) {}
};